import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b0495a6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "todos"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "checkbox" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "content" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "empty-todos"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "msg" }, "Фух! У вас нет задач", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return ($setup.todos.length > 0)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.todos, (todo) => {
          return (_openBlock(), _createElementBlock("li", {
            class: _normalizeClass(["todos-item", { completed: todo.completed }]),
            key: todo.id
          }, [
            (todo.completed)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "check-btn",
                  onClick: ($event: any) => ($setup.handleMarkCompleted(todo.id))
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "check",
                    class: "check"
                  })
                ], 8, _hoisted_2))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "checkbox-btn",
                  onClick: ($event: any) => ($setup.handleMarkCompleted(todo.id))
                }, _hoisted_5, 8, _hoisted_3)),
            _createElementVNode("p", _hoisted_6, _toDisplayString(todo.content), 1),
            _createElementVNode("button", {
              class: "close-btn",
              onClick: ($event: any) => ($setup.handleDeleteTodo(todo.id))
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: "times",
                class: "close"
              })
            ], 8, _hoisted_7)
          ], 2))
        }), 128))
      ]))
    : ($setup.allTodos.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_font_awesome_icon, {
            icon: "clipboard-check",
            class: "icon"
          }),
          _hoisted_9
        ]))
      : _createCommentVNode("", true)
}